export function extractError(e: unknown): string | undefined {
  if (e instanceof Error) {
    // handle FetchErrors
    if (
      'data' in e &&
      e.data instanceof Object &&
      'message' in e.data &&
      e.data.message
    ) {
      return String(e.data.message);
    }

    if (e.name && e.name !== 'Error') {
      return `${e.name}: ${e.message}`;
    }

    return e.message;
  }
  if (typeof e === 'string') {
    return e;
  }
}
